export const ZoomDefaults = {
  increment: 0.2,
  min: 0.4,
  max: 3,
} as const;
